import UserRole from './UserRole';

export default class UserInfo {
  public company?: string;
  public name?: string;
  public nickname?: string;
  public owner?: string | boolean;
  public roles?: string | UserRole[];
  public sub?: string;
  public subject?: string;
}
